import { driversMockDatas } from "mock/datas/drivers"
import { entitiesMockData } from "mock/datas/entities"
import { invoicesMockDatas } from "mock/datas/invoices"
import { rfidsMockDatas } from "mock/datas/rfidcards"
import { sessionsMockDatas } from "mock/datas/sessions"
import { stationsMockDatas } from "mock/datas/stations"
import { paymentsMockDatas } from "mock/datas/payment.ts";
import { EntitySchema, DriverSchema, RfidSchema, PaymentSchema, SessionsSchema } from "mock/schemas"
import { StationsInfo } from "types/stations"
import {InvoiceSchema} from "mock/invoiceSchema.ts";


export class CommunicationService {
    drivers: DriverSchema[]
    stations: StationsInfo[]
    entities: EntitySchema[]
    rfidCards: RfidSchema[]
    invoices: InvoiceSchema[]
    payments: PaymentSchema[]
    sessions: SessionsSchema[]

    delay: number

    constructor(delay: number = 300) {
        this.drivers = driversMockDatas.map((d) => ({ ...d }))
        this.stations = stationsMockDatas.map((d) => ({ ...d }))
        this.entities = entitiesMockData.map((d) => ({ ...d }))
        this.rfidCards = rfidsMockDatas.map((d) => ({ ...d }))
        this.invoices = invoicesMockDatas.map((d) => ({ ...d }))
        this.payments = paymentsMockDatas.map((d) => ({ ...d }))
        this.sessions = sessionsMockDatas.map((d) => ({ ...d }))
        this.delay = delay
    }

    numberOfRfidCardsPerDriver = (driver_id: string): number => {
        return this.rfidCards.filter(
            (r) => r.driver_id === driver_id && r.active && !r.toBeActivated
        ).length
    }

    numberOfRfidCardsPerEntity = (entity_id: string): number => {
        return this.rfidCards.filter((r) => r.entity_id === entity_id).length
    }

    numberOfDriversPerEntity = (entity_id: string): number => {
        return this.drivers.filter((d) => d.entity_id === entity_id).length
    }
}